export default __webpack_public_path__ + "static/enrique-avatar-d99e140f72821236e96bc95f373d0913.png";